import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'device-ipad-horizontal-minus',
  'IconDeviceIpadHorizontalMinus',
  [
    [
      'path',
      {
        d: 'M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9',
        key: 'svg-0',
      },
    ],
    ['path', { d: 'M9 17h3.5', key: 'svg-1' }],
    ['path', { d: 'M16 19h6', key: 'svg-2' }],
  ],
);
